import { Box, BoxProps } from "@mantine/core";

interface ParentsBoxProps extends BoxProps {
  children: React.ReactNode;
}

export const ParentsBox = ({ children, ...params }: ParentsBoxProps) => {
  return (
    <Box
      bg={"gainsboro"}
      w={"44rem"}
      p={"8px"}
      style={{
        borderRadius: "4px",
      }}
      {...params}
    >
      {children}
    </Box>
  );
};
